const checkIsSelectedHotel = (hotelItinerary, hotelItinerariesToCompare) => {
  if (
    !hotelItinerary ||
    !hotelItinerariesToCompare ||
    !(Object.keys(hotelItinerariesToCompare).length > 0)
  )
    return false;

  const compareHotels = (hotel1, hotel2) =>
    hotel1.hotelKey === hotel2.hotelKey &&
    hotel1.startDateTime === hotel2.startDateTime &&
    hotel1.endDateTime === hotel2.endDateTime;

  const itemsToCompare = Array.isArray(hotelItinerariesToCompare)
    ? hotelItinerariesToCompare
    : [hotelItinerariesToCompare];
  return itemsToCompare.some((item) => compareHotels(hotelItinerary, item));
};

export default checkIsSelectedHotel;
